import styled from 'styled-components';
import { unthemed, zIndex } from 'tokens';

export const ControlBox = styled.div`
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

export const FrameTitle = styled.div`
	font-size: 12px;
	font-weight: 600;
	color: ${unthemed.gray['0']};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 100%;
	flex: 1;
`;

export const ActionsBox = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	pointer-events: none;
	gap: 4px;
	margin-top: 0px;
`;

export const ActionsBox2 = styled(ActionsBox)`
	gap: 2px;
	width: 100%;
`;

export const ActionsBox2Spacer = styled.div`
	width: 2px;
`;

export const Icon = styled.div`
	margin-right: 6px;
`;

interface ActionProps {
	disabled?: boolean;
}

export const Action = styled.div<ActionProps>`
	background: ${unthemed.blue['500']};
	pointer-events: auto;
	color: ${unthemed.gray['0']};
	display: inline-block;
	padding: 0px 4px;
	border-radius: 3px;
	opacity: ${(props) => (props.disabled ? 0.4 : 0.8)};
	${(props) =>
		!props.disabled &&
		`
		&:hover {
			background: ${unthemed.blue['600']};
		}
		&:active {
			background: ${unthemed.blue['700']};
		}
	`}
`;

export const Action2 = styled(Action)`
	margin-top: -4px;
	background: transparent;
	${(props) =>
		!props.disabled &&
		`
		&:hover {
			background: ${unthemed.gray['1000']};
		}
		&:active {
			background: ${unthemed.gray['800']};
		}
	`}
`;

export const IconWrapper = styled.div`
	margin-top: -2px;
`;

interface FrameBaseProps {
	highlighted?: boolean;
}

const FrameBase = styled.div<FrameBaseProps>`
	position: absolute;
	background: ${(props) => (props.highlighted ? '#391252' : unthemed.gray['1000'])};
	pointer-events: none;
	// z-index: ${zIndex.panel};
	border-radius: 0px;
`;

export const FrameTop = styled(FrameBase)`
	border-radius: 8px 8px 0 0;
`;

export const FrameBottom = styled(FrameBase)`
	border-radius: 0 0 8px 8px;
`;

export const FrameLeft = styled(FrameBase)``;

export const FrameRight = styled(FrameBase)``;

// Mask overlay components for semi-transparent overlay around frame bounds
export const Mask = styled.div`
	position: absolute;
	background: rgba(0, 0, 0, 0.5);
	pointer-events: none;
`;
